import _ from 'underscore';

import {
  BMCTemplateFactory,
  OtherSectionFactory,
  TextWithCustomValidatorView,
} from '../custom-controls/index';

export class OtherFields {
  constructor({
    isExpanded = false,
    i18n,
    model,
    flattenedSchemaGenerator,
    isForVNext,
    isDSAMixedModeCampaignEnabled,
    isPauseAdGroupIfNoLocationSupportedEnabled = false,
    isAudienceTargetForFBImportOptionEnabled = false,
    shouldEnableBSCSmartImport,
    permissions,
  }) {
    this.isExpanded = isExpanded;
    this.i18n = i18n;
    this.model = model;
    this.bmcFactory = new BMCTemplateFactory({
      i18n,
    });
    this.otherSectionFactory = new OtherSectionFactory({
      i18n,
    });
    this.isDSAMixedModeCampaignEnabled = isDSAMixedModeCampaignEnabled;
    this.isForVNext = isForVNext;
    this.isPauseAdGroupIfNoLocationSupportedEnabled = isPauseAdGroupIfNoLocationSupportedEnabled;
    this.isAudienceTargetForFBImportOptionEnabled = isAudienceTargetForFBImportOptionEnabled;
    this.shouldEnableBSCSmartImport = shouldEnableBSCSmartImport;
    this.isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled =
      permissions.IsPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled;

    const suffixProp =
      flattenedSchemaGenerator.getFlattenedSchemaWithProperties('ImportPrefixAndSuffixForStringProperty_SuffixString');

    this.maxCampaignNameLength = suffixProp.maxLength;

    this.isAdScheduleUseSearcherTimezoneEnabled =
      permissions.IsAdScheduleUseSearcherTimezoneEnabled;
  }

  getOtherSubFields() {
    const hasStore = this.model.AvailableStoreValues.length > 0;

    return _.compact([
      {
        property: 'ImportAppendDestUrlPreference_UseAppendString',
        label: this.i18n.getString('Import_ImportOptions_AdUrlsOptions'),
        message: this.i18n.getString('ImportAppendDestUrlPreference_UseAppendString'),
        control: this.otherSectionFactory.generateOtherItemTemplateForForm(this.i18n.getString('Import_ImportOptions_EditAdUrls')),
      },
      {
        property: 'ImportAppendDestUrlPreference_AppendStringForDestinationUrl',
        control: TextWithCustomValidatorView,
        message: '',
        label: '',
        ariaLabel: this.i18n.getString('ImportAppendDestUrlPreference_UseAppendString'),
        visible: {
          depends: ['ImportAppendDestUrlPreference_UseAppendString'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_Append_AdUrls'),
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString',
        label: '',
        message: this.i18n.getString('ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString'),
      },
      {
        property: 'ImportSearchAndReplaceDestUrlPreference_SearchStringForDestinationUrl',
        control: this.otherSectionFactory.generateFindViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_FindReplace_AdUrls'),
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'ImportSearchAndReplaceDestUrlPreference_ReplaceStringForDestinationUrl',
        control: this.otherSectionFactory.generateReplaceViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString'],
          computedBy: _.identity,
        },
        valueUpdate: 'input',
      },
      {
        property: 'AppendPreferencesForTrackingTemplate_UseAppendString',
        label: this.i18n.getString('Import_ImportOptions_TrackingTemplateOptions'),
        message: this.i18n.getString('AppendPreferencesForTrackingTemplate_UseAppendString'),
        control: this.otherSectionFactory.generateOtherItemTemplateForForm(this.i18n.getString('Import_ImportOptions_EditTrackingTemplate')),
      },
      {
        property: 'AppendPreferencesForTrackingTemplate_AppendStringForTrackingTemplate',
        control: TextWithCustomValidatorView,
        message: '',
        label: '',
        ariaLabel: this.i18n.getString('AppendPreferencesForTrackingTemplate_UseAppendString'),
        visible: {
          depends: ['AppendPreferencesForTrackingTemplate_UseAppendString'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_Append_TrackingTemplate'),
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString',
        label: '',
        message: this.i18n.getString('SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString'),
      },
      {
        property: 'SearchAndReplacePreferencesForTrackingTemplate_SearchStringForTrackingTemplate',
        control: this.otherSectionFactory.generateFindViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_FindReplace_TrackingTemplate'),
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'SearchAndReplacePreferencesForTrackingTemplate_ReplaceStringForTrackingTemplate',
        control: this.otherSectionFactory.generateReplaceViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString'],
          computedBy: _.identity,
        },
        valueUpdate: 'input',
      },
      {
        property: 'SearchAndReplaceForCustomParameters_EnableSearchAndReplace',
        label: '',
        message: this.i18n.getString('Import_ImportOptions_CustomParameter_FindAndReplace'),
      },
      {
        property: 'SearchAndReplaceForCustomParameters_SearchString',
        control: this.otherSectionFactory.generateFindViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['SearchAndReplaceForCustomParameters_EnableSearchAndReplace'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_FindReplace_CustomParameters'),
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'SearchAndReplaceForCustomParameters_ReplaceString',
        control: this.otherSectionFactory.generateReplaceViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['SearchAndReplaceForCustomParameters_EnableSearchAndReplace'],
          computedBy: _.identity,
        },
        valueUpdate: 'input',
      },
      {
        property: 'SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace',
        label: '',
        message: this.i18n.getString('Import_ImportOptions_FinalSuffix_FindAndReplace'),
      },
      {
        property: 'SearchAndReplaceForFinalURLSuffix_SearchString',
        control: this.otherSectionFactory.generateFindViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_FindReplace_FinalSuffix'),
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'SearchAndReplaceForFinalURLSuffix_ReplaceString',
        control: this.otherSectionFactory.generateReplaceViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace'],
          computedBy: _.identity,
        },
        valueUpdate: 'input',
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateNameForExistingCampaigns',
        label: this.i18n.getString('Import_ImportOptions_CampaignOptionsHeader'),
        message: this.i18n.getString('ImportUpdateEntityPreference_UpdateNameForExistingCampaigns'),
        control: 'checkbox',
      },
      {
        property: 'ImportNewOption_ImportNewCampaignsAndMarkAsPaused',
        message: this.i18n.getString('ImportNewOption_ImportNewCampaignsAndMarkAsPaused'),
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewActiveEntitiesOnly',
        message: this.i18n.getString('Import_ImportOptions_ImportNewPausedEntities'),
        showLabel: false,
      },
      this.isAdScheduleUseSearcherTimezoneEnabled && {
        property: 'AdScheduleUseSearcherTimezone',
        message: this.i18n.getString('Import_ImportOptions_AdScheduleUseSearcherTimezone'),
        control: 'checkbox',
        showLabel: false,
      },
      !this.isDSAMixedModeCampaignEnabled ? {
        property: 'ImportSearchAndDsaMixedCampaignAsSearchCampaign',
        message: this.i18n.getString('Import_ImportOptions_ImportDSAMixedAsSearch'),
        showLabel: false,
        control: 'checkbox',
      } : null,
      {
        property: 'ImportPrefixAndSuffixForStringProperty_EnablePrefixAndSuffix',
        message: this.i18n.getString('Import_ImportOptions_CampaignName_InsertAtEnd'),
        showLabel: false,
        control: this.otherSectionFactory.generateOtherItemTemplateForForm(''),
      },
      {
        property: 'ImportPrefixAndSuffixForStringProperty_SuffixString',
        control: TextWithCustomValidatorView,
        message: '',
        label: '',
        ariaLabel: this.i18n.getString('Import_ImportOptions_CampaignName_InsertAtEnd'),
        visible: {
          depends: ['ImportPrefixAndSuffixForStringProperty_EnablePrefixAndSuffix'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_Append_CampaignName'),
          },
          maxLength: {
            message: this.i18n.getString('Validation_String_Max_Length').replace('{{maxlength}}', this.maxCampaignNameLength),
            blockInput: true,
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace',
        label: '',
        message: this.i18n.getString('Import_ImportOptions_CampaignName_FindAndReplace'),
      },
      {
        property: 'ImportSearchAndReplaceForStringProperty_SearchString',
        control: this.otherSectionFactory.generateFindViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace'],
          computedBy: _.identity,
        },
        required: true,
        validators: {
          required: {
            message: this.i18n.getString('Validation_ImportOptions_FindReplace_CampaignName'),
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'ImportSearchAndReplaceForStringProperty_ReplaceString',
        control: this.otherSectionFactory.generateReplaceViewForForm(),
        message: '',
        label: '',
        visible: {
          depends: ['ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace'],
          computedBy: _.identity,
        },
        validators: {
          maxLength: {
            message: this.i18n.getString('Validation_String_Max_Length').replace('{{maxlength}}', this.maxCampaignNameLength),
            blockInput: true,
          },
        },
        valueUpdate: 'input',
      },
      {
        property: 'RenameCampaignNameWithSuffix',
        message: this.i18n.getString('Import_ImportOptions_RenameCampaignNameWithSuffixOption'),
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportAllAdUnderAnAdGroup',
        label: this.i18n.getString('Import_ImportOptions_AdOptionsHeader'),
        message: this.i18n.getString('Import_ImportOptions_ImportNewPausedAds'),
      },
      {
        property: 'PauseParentIfNoLocationSupported',
        label: this.i18n.getString('Import_ImportOptions_LocationTarget'),
        message: this.i18n.getString('Import_ImportOptions_PauseParentIfNoLocationSupported'),
        control: 'checkbox',
      },
      this.isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled && {
        property: 'PauseAIMAdGroupIfAllAudienceCriterionNotImported',
        message: this.i18n.getString('Import_ImportOptions_PauseAIMAdGroupIfAllAudienceCriterionNotImported'),
        showLabel: false,
      },
      {
        property: 'EnableParentLocationMapping',
        message: this.i18n.getString('Import_ImportOptions_EnableParentLocationMapping'),
        showLabel: false,
      },
      !this.shouldEnableBSCSmartImport && {
        property: 'StoreIdForImportedProductAdExtensionsFlag',
        label: this.i18n.getString('Import_ImportOptions_ShoppingCampaignOptions'),
        message: this.i18n.getString('StoreIdForImportedProductAdExtensionsFlag'),
        control: this.bmcFactory.generateBmcCheckboxTemplateFunctionForForm(hasStore),
      },
      !this.shouldEnableBSCSmartImport && {
        property: 'StoreIdForImportedProductAdExtensions',
        label: '',
        message: '',
        ariaLabel: this.i18n.getString('StoreIdForImportedProductAdExtensionsFlag'),
        control: this.bmcFactory.generateDropdownViewForForm(this.isForVNext),
        values: this.model.AvailableStoreValues,
        valueMessages: this.model.AvailableStoreValueMessages,
      },
      this.isPauseAdGroupIfNoLocationSupportedEnabled && {
        property: 'PauseAdGroupIfNoLocationSupported',
        message: this.i18n.getString('Import_ImportOptions_PauseAdGroupIfNoLocationSupported'),
        showLabel: false,
      },
      this.isAudienceTargetForFBImportOptionEnabled && {
        property: 'NoAudienceTargetForFBImportOption',
        message: this.i18n.getString('Import_ImportOptions_NoAudienceTargetForFBImportOption'),
        showLabel: false,
      },
    ]);
  }

  getOtherFields() {
    return [
      {
        type: 'collapse',
        text: this.i18n.getString('Import_ImportOptions_OtherOptionsHeader'),
        isExpanded: this.isExpanded,
        fields: this.getOtherSubFields(),
        className: 'other-options-collapse scheduling-form',
      },
    ];
  }
}
